import React, { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';

const AppSubscribeModalApp = lazy(() => import('./AppSubscribeModalApp'));

export const initAppSubscribeModal = () => {
  const triggers = document.querySelectorAll('[data-modal-app-trigger]');
  const portalNode = document.getElementById('app-subscribe-modal');

  if (!portalNode || !triggers.length) return;

  let root = null;

  const closeModal = () => {
    if (root) {
      root.unmount();
      root = null;
    }
  };

  const openModal = (variant) => {
    if (!root) {
      root = createRoot(portalNode);
    }

    root.render(
      <Suspense fallback={null}>
        <AppSubscribeModalApp
          onClose={closeModal}
          translations={window.appSubscribeModalTranslations}
          variant={variant}
        />
      </Suspense>,
    );
  };

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => openModal(trigger.dataset.modalAppVariant));
  });
};

initAppSubscribeModal();
